import { createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/side-banner-003.jpeg'


const _withScopeId = n => (_pushScopeId("data-v-1a35c68c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "side-banner-img",
  src: _imports_0
}, null, -1))
const _hoisted_2 = [
  _hoisted_1
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_ripple = _resolveDirective("ripple")!

  return _withDirectives((_openBlock(), _createElementBlock("a", {
    class: "side-banner",
    rel: "noopener",
    href: "https://www.sberbank.com/ru/s_m_business/bankingservice/cards/corporatecards",
    target: "_blank",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.analytics.yandexCounter(92706008, 'reachGoal', 'lk-baner-sber-karta')))
  }, _hoisted_2)), [
    [_directive_ripple]
  ])
}